<template>
  <div
    tabindex="0"
    :class="['c-grid-header', { 'c-grid-header--focused': false }]"
  >
    <div class="c-grid-header__wrapper">
      <div class="c-grid-header__static" style="min-width: 80px">
        <Avatar :size="'sm'" :text="getInitials" :image="domainImage"></Avatar>
      </div>
      <div class="c-grid-header__column"></div>
    </div>
  </div>
</template>

<script>
import { MoreVerticalIcon, CheckIcon } from "vue-feather-icons";
import Avatar from "@/components/ui/avatar";
export default {
  components: {
    MoreVerticalIcon,
    CheckIcon,
    Avatar,
  },
  data: function () {
    return {
      _domainImage: false,
    };
  },
  props: ["href"],
  computed: {
    domainImage: function () {
      var url = this._domainImage;
      if (url) {
        return url;
      } else {
        this.$store.dispatch("cache/fetchMetadata", "https://" + this.href);
        return null;
      }
    },
  },
  methods: {
    getInitials: function () {
      var href = this.href;
      var gg = href.split(".");
      if (!gg[1]) {
        return href[0] + href[1];
      }
      gg = gg[gg.length - 2];
      return gg[0] + gg[1];
    },
  },
};
</script>

<style lang="scss">
.c-grid-header {
  position: relative;

  &:focus {
    outline: none;
  }

  &__wrapper {
    display: flex;
    position: relative;
  }

  &__column {
    position: relative;
    //border-right: var(--g4) solid 1px;
    border-bottom: var(--g4) solid 1px;
    //background-color: var(--p4);

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: transparent;
    }

    &__inner {
      height: 100%;
      display: flex;
      justify-content: center;
      max-height: var(--grid-height);
      overflow-y: hidden;
    }
  }

  &__static {
    position: relative;
    border-right: var(--g2) solid 1px;
    background-color: var(--g4);
    display: flex;
    align-headers: flex-start;

    .custom-control {
      height: 24px;

      .custom-control-label {
        &:before {
          top: -6px;
        }
        &:after {
          top: -6px;
        }
      }
    }

    &:after {
      content: "";
      position: absolute;
      z-index: 10;
      top: 0;
      left: 0;
      width: 2px;
      height: 100%;
      background-color: transparent;
    }
  }

  &__text {
    display: inline-flex;
    align-headers: center;
    padding: $lg-margins / 2 $lg-margins * 2;
    font-size: var(--font-size-xs);
  }

  &__article {
    width: 100%;
    display: inline-block;
    padding: $lg-margins / 2 $lg-margins * 2;
    opacity: 0.85;
  }

  &__block {
    padding: $lg-margins / 2 $lg-margins * 2;
  }

  &__dragger {
    position: relative;
    margin-top: 3px;
    width: 24px;
    height: 24px;
    margin-left: 4px;
    opacity: 0.8;
    transition: opacity 50ms linear;
    cursor: grab;
    svg {
      position: absolute;
      top: calc(50% - 8px);
      left: 0;
      display: inline-block;

      &:last-child {
        left: 6px;
      }
    }

    &:hover,
    &:active {
      opacity: 1;
    }
  }

  .c-text-renderer {
    padding: $lg-margins / 2 $lg-margins * 2;
    width: 100%;

    &--code {
      border-radius: 0;
      border: none;
    }
  }

  &__control {
    position: relative;
    width: 40px;
    cursor: pointer;
    user-select: none;
    margin-top: 16px;

    > span {
      display: block;
      position: absolute;
      bottom: calc(50% - 10px);
      left: 9px;
      width: 20px;
      height: 20px;
      border-radius: 3px;
      background-color: var(--p5);
      border: var(--p4) solid 2px;
      transition: all 60ms linear;

      svg {
        display: block;
        stroke: var(--p5);
        stroke-width: 4px;
      }
    }

    &.first {
      &:after {
        top: auto;
        bottom: 0;
        height: 50%;
      }
    }

    &.last {
      &:after {
        height: 50%;
      }
      &.first {
        &:after {
          content: none;
        }
      }
    }

    &:hover {
      > span {
        background-color: var(--p4);
        border-color: var(--p4);
        svg {
          stroke: var(--p5);
        }
      }
    }
    &.selected {
      background-color: var(--g3);
      z-index: 10;

      > span {
        background-color: var(--p3);
        border-color: var(--p3);
        svg {
          stroke: var(--p5);
        }
      }
    }
  }

  &--focused {
    border-color: var(--s4);
    max-height: var(--grid-height);

    .c-grid-header__wrapper {
      z-index: 1;
      box-shadow: 0 1.3px 3.1px rgba(0, 0, 0, 0.145),
        0 4.5px 10.3px rgba(0, 0, 0, 0.215), 0 20px 46px rgba(0, 0, 0, 0.36);
    }
    .c-grid-header__column {
      background-color: var(--p5);
      border-color: var(--p4);

      &:before {
        background-color: var(--p4);
      }

      &__inner {
        max-height: initial;
      }
    }
    .c-grid-header__static {
      &:after {
        background-color: var(--p3);
      }
    }
  }
}
</style>